import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ConnectionService } from '../../service/connection.service';

@Component({
  selector: 'app-conferma-email',
  standalone: true,
  imports: [CommonModule, FormsModule, RouterLink, TranslatePipe],
  templateUrl: './conferma-email.component.html',
  styleUrl: './conferma-email.component.css',
})
export class ConfermaEmailComponent implements OnInit {
  loading = true;
  done = false;
  error = '';
  showResendForm = false;
  resendEmail = '';
  resendLoading = false;
  resendSent = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private connection: ConnectionService,
  ) {}

  ngOnInit() {
    const token = this.route.snapshot.queryParamMap.get('token') ?? '';
    if (!token) {
      this.loading = false;
      this.showResendForm = true;
      return;
    }
    this.connection.post(
      '@auth/confirm-email',
      { token },
      () => {
        this.loading = false;
        this.done = true;
        setTimeout(() => this.router.navigate(['/login']), 3000);
      },
      (err: any) => {
        this.loading = false;
        this.error = err?.error?.message ?? 'Link non valido o scaduto.';
        this.showResendForm = true;
      },
    );
  }

  resend() {
    if (!this.resendEmail.trim()) return;
    this.resendLoading = true;
    this.connection.post(
      '@auth/resend-confirmation',
      { email: this.resendEmail.trim() },
      () => {
        this.resendLoading = false;
        this.resendSent = true;
      },
      () => {
        this.resendLoading = false;
        this.resendSent = true;
      },
    );
  }
}
